<template>
    <div class="simple-layout">
        <div class="message-box-404">
            <div class="message-404">
                <span class="message">Это код ошибки</span>
                <img class="arrow" width="100" src="../../public/arrow.png">
            </div>
            <h1 class="error-msg error">404</h1>
        </div>
        <div class="video">
            <div class="video-message">
                <span class="message">Расслабьтесь немного 😎</span>
                <img class="arrow" width="100" src="../../public/arrow.png">
            </div>
            <iframe src="https://www.youtube.com/embed/G1IbRujko-A"
                    width="100%" height="315" frameborder="0" allowfullscreen></iframe>
        </div>
        <v-button style="margin: 0" @click="$router.push('/')" label="Вернуться в личный кабинет"/>
    </div>
</template>

<script>
import vButton from "../components/vButton";

export default {
  name: "forMisha",
  components: {
    vButton
  },
};
</script>

<style lang="sass" scoped>
    .simple-layout
        text-align: center

        .message-box-404
            margin: gridSteps(5) auto
            width: 250px
            height: 240px
            position: relative
            .message-404
                position: absolute
                top: -40px
                left: 30px
                .arrow
                    top: 152px
                    left: -171px
                    transform: scale(-1) scaleY(-1) rotate(70deg)
                    position: absolute
                .message
                    position: absolute
                    font-weight: bold
                    color: black
                    top: 152px
                    left: -211px
                    transform: rotate(-22deg)


        .video
            box-shadow: $standard-elevation
            width: 600px
            position: relative
            margin: gridSteps(1) auto gridSteps(4)
            .video-message
                .arrow
                    top: 110px
                    height: 80px
                    width: 170px
                    left: -171px
                    transform: scaleX(-1) rotate(48deg)
                    position: absolute
                .message
                    top: 90px
                    height: 80px
                    width: 170px
                    font-weight: bold
                    width: 200px
                    color: black
                    left: -190px
                    transform: rotate(-30deg)
                    position: absolute


        .simple-layout
            position: absolute
            width: 100vw
            height: 100vh
            background: #F2F2F2

        .page-not-found
            margin: -60px

        .error
            text-align: center
            transform: rotate(-15deg)
            font-size: 210px
            margin: -70px
            padding: 0

        .message-box
            width: 500px
            margin: 100px auto
            padding: 50px
            text-align: center
            background: white
            box-shadow: $standard-elevation
            color: black

        button
            margin: 100px 0 0 0

</style>
